export const BaseViewType = {
  showAlert: "[BaseView] showAlert",
};
